var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgScene = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M10 1.874a8.125 8.125 0 1 0 0 16.25 8.125 8.125 0 0 0 0-16.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M10 1.874C7.73 1.874 5.599 5.512 5.599 10s2.132 8.125 4.4 8.125c2.27 0 4.402-3.638 4.402-8.125S12.268 1.874 10 1.874Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4.584 4.583C6.077 5.643 7.958 6.276 10 6.276s3.923-.633 5.417-1.693"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15.417 15.417c-1.494-1.06-3.374-1.693-5.417-1.693s-3.923.633-5.416 1.693"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M10 1.874v16.25"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M18.125 9.999H1.875"
  })));
};
export { SvgScene as ReactComponent };